module.exports = __webpack_public_path__ + "media/images/flags/64/European-Union-01374f572f7d59de3100e434218c32c3.png";